<template>
    <div class="clock-in-lottery">
        <div id="header">
            <img class="back" src="../../assets/common_back.png" alt=""
                 @click="back">
            <span class="title">购买达标抽奖</span>
        </div>
        <!-- 轮盘容器 -->
        <div class="wheel-container">
            <div class="wheel-wrapper">
                <!-- Canvas 轮盘 -->
                <canvas v-show="!canvasHidden" id="wheelCanvas" class="wheel-canvas" ref="wheelCanvas"></canvas>
                <div class="lottery-ticket-badge">
                    <div class="lottery-ticket-label">剩余抽奖次数</div>
                    <div class="lottery-ticket-value">{{lotteryTicketNumber}}</div>
                    <div class="lottery-ticket-label">剩余达标次数</div>
                    <div class="lottery-ticket-value">{{qualifyNumber}}</div>
                </div>
            </div>

            <!-- 控制区域 -->
            <div class="controls">
                <div class="result-panel">
                    <span class="result-label">中奖礼品</span>
                    <span class="prize-name">{{ prizeDisplay }}</span>
                </div>
                <button class="spin-btn" @click="spinWheel" :disabled="spinning">抽奖</button>
            </div>
        </div>

        <!-- 抽奖规则 -->
        <div class="rule-container">
            <div class="rule-title">抽奖规则</div>
            <div class="rule-content">{{remark}}</div>
        </div>

        <!-- 中奖场景弹窗 -->
        <base-dialog v-if="lotteryVisible" :title="title" :visible.sync="lotteryVisible" display="none" width="80%">
            <div class="message">恭喜中奖：{{ prizeName }}</div>
            <div class="message" v-if="!isStamp">请下次下单时使用！</div>
            <div class="tip-emphasis" v-if="!isStamp">该礼品券有效期{{validity}}天，请尽快使用！</div>
            <div class="tip-emphasis" v-if="!isStamp">过期时间:{{ expireTime }}</div>
            <div class="acknowledge-container" v-if="!isStamp">
                <div class="checkbox-checkbox" @click="toggleAcknowledged">
                    <img v-if="acknowledged" src="../../assets/check_box_rounded.png" alt="" style="width: 14px; height: 14px; border-radius: 50%;">
                    <div v-else class="checkbox-border-small"></div>
                </div>
                <div class="tip" style="font-weight: bold;">抽奖中奖后的电子券必须{{validity}}天内使用，否则失效并且不回退抽奖抵扣的次数</div>
            </div>
            <div class="message" v-if="isStamp">已自动存入账户！</div>
            <div class="dialog-buttons">
<!--                <button class="tip-cancel" :disabled="!isStamp && !acknowledged" @click="stampShopDetail">查看</button>-->
                <button class="tip-ok" :disabled="!isStamp && !acknowledged" @click="submit">确认<span v-if="!isStamp">（勾选后可以确定）</span></button>
            </div>
        </base-dialog>

        <!-- Toast 提示 -->
        <Toast ref="toast"></Toast>
    </div>
</template>

<script>
import {giftWheelList, giftLottery, lotteryTicketNumber, getStampShopActivity, getVoucher} from '@/api/StampShop'
import BaseDialog from "@/components/BaseDialog.vue";
import {parseTime} from "../../unitls"

export default {
    name: 'ClockInLottery',
    components: {BaseDialog},
    data() {
        return {
            activityId: '',
            stampExchangeLogId: '',
            voucherId: '',
            spinning: false,
            prizeDisplay: '🌸 -',
            canvasWidth: 500,
            canvasHeight: 500,
            lotteryVisible: false,
            validity: '',
            title: '中奖提示',
            prizeName: '',
            expireTime: '',
            canvasHidden: false,
            isStamp: false,
            acknowledged: false,
            lotteryTicketNumber: 0,
            qualifyNumber: 0,
            remark: '',
            prizes: [],
            colors: [
                '#ffdfe0',
                '#fef2d3',
                '#ffb6c1',
                '#ffa5b0',
                '#fadadd',
                '#ffc0cb'
            ],
            currentRotation: 0.0,
            animFrame: null,
            ctx: null,
            canvas: null
        }
    },
    created() {
        this.activityId = this.$route.query.activityId
    },
    mounted() {
        this.loadData()
    },
    beforeDestroy() {
        if (this.animFrame) {
            clearTimeout(this.animFrame)
        }
    },
    methods: {
        // Toast 提示方法
        toast(e) {
            this.$refs.toast.show(e, 1500);
        },
        async loadData() {
            try {
                const res = await giftWheelList({ activityId: this.activityId })

                if (res.code === this.$API_CODE.OK) {
                    const prizes = []
                    res.data.forEach(item => {
                        prizes.push({
                            emoji: item.emoji,
                            name: item.name
                        })
                    })
                    this.prizes = prizes

                    setTimeout(() => {
                        this.initCanvas()
                    }, 500)
                } else {
                    this.toast(res.message)
                }
            } catch (error) {
                console.error('加载奖品列表失败:', error)
            }
            await this.getLotteryTicketNumber()
            await this.getStampShopActivity()
        },

        /**
         * 获取抽奖次数
         */
        async getLotteryTicketNumber() {
            try {
                const res = await lotteryTicketNumber({ activityId: this.activityId })

                if (res.code === this.$API_CODE.OK) {
                    this.lotteryTicketNumber = res.data.unUsedLotteryTicketNumber
                    this.qualifyNumber = 7 - res.data.totalLotteryTicketNumber
                }
            } catch (error) {
                console.error('获取抽奖次数失败:', error)
            }
        },

        // 获取活动信息
        async getStampShopActivity() {
            try {
                const res = await getStampShopActivity({ activityId: this.activityId })

                if (res.code === this.$API_CODE.OK) {
                    this.remark = res.data.remark
                }
            } catch (error) {
                console.error('获取活动信息失败:', error)
            }
        },

        /**
         * 初始化 Canvas
         */
        initCanvas() {
            this.$nextTick(() => {
                const canvasEl = this.$refs.wheelCanvas
                if (!canvasEl) return

                const ctx = canvasEl.getContext('2d')
                const dpr = window.devicePixelRatio || 1

                canvasEl.width = 500 * dpr
                canvasEl.height = 500 * dpr
                canvasEl.style.width = '500px'
                canvasEl.style.height = '500px'
                ctx.scale(dpr, dpr)

                this.canvas = canvasEl
                this.ctx = ctx
                this.canvasWidth = 500
                this.canvasHeight = 500

                this.drawWheel(0)
            })
        },

        resetCanvas() {
            this.canvas = null
            this.ctx = null
        },

        /**
         * 标准化角度
         */
        normalizeAngle(angle) {
            const TAU = 2 * Math.PI
            angle = angle % TAU
            if (angle < 0) angle += TAU
            return angle
        },

        /**
         * 根据旋转角度获取奖品索引
         */
        getPrizeIndexFromRotation(rot) {
            const PI = Math.PI
            const TAU = 2 * PI
            const SEGMENT_COUNT = this.prizes.length
            const ANGLE_STEP = TAU / SEGMENT_COUNT

            let pointerAngle = (-PI / 2 - rot) % TAU
            pointerAngle = this.normalizeAngle(pointerAngle)

            for (let i = 0; i < SEGMENT_COUNT; i++) {
                let start = i * ANGLE_STEP - PI / 2
                let end = start + ANGLE_STEP
                start = this.normalizeAngle(start)
                end = this.normalizeAngle(end)

                if (start < end) {
                    if (pointerAngle >= start && pointerAngle < end) return i
                } else {
                    if (pointerAngle >= start || pointerAngle < end) return i
                }
            }
            return 0
        },

        /**
         * 绘制轮盘
         */
        drawWheel(rot) {
            const ctx = this.ctx
            if (!ctx) return

            const CENTER_X = this.canvasWidth / 2
            const CENTER_Y = this.canvasHeight / 2
            const RADIUS = 220
            const PI = Math.PI
            const TAU = 2 * PI
            const SEGMENT_COUNT = this.prizes.length
            const ANGLE_STEP = TAU / SEGMENT_COUNT

            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)

            for (let i = 0; i < SEGMENT_COUNT; i++) {
                const start = i * ANGLE_STEP - PI / 2 + rot
                const end = start + ANGLE_STEP

                ctx.beginPath()
                ctx.moveTo(CENTER_X, CENTER_Y)
                ctx.arc(CENTER_X, CENTER_Y, RADIUS, start, end)
                ctx.closePath()
                ctx.fillStyle = this.colors[i % this.colors.length]
                ctx.fill()

                ctx.save()
                ctx.shadowColor = 'rgba(230, 22, 64, 0.3)'
                ctx.shadowBlur = 10
                ctx.strokeStyle = '#ffffff'
                ctx.lineWidth = 2.2
                ctx.stroke()
                ctx.restore()

                ctx.beginPath()
                ctx.moveTo(CENTER_X, CENTER_Y)
                ctx.lineTo(CENTER_X + RADIUS * Math.cos(start), CENTER_Y + RADIUS * Math.sin(start))
                ctx.strokeStyle = '#e61640'
                ctx.lineWidth = 2.5
                ctx.stroke()

                const midAngle = start + ANGLE_STEP / 2
                const textRadius = RADIUS * 0.62
                const x = CENTER_X + textRadius * Math.cos(midAngle)
                const y = CENTER_Y + textRadius * Math.sin(midAngle)

                ctx.save()
                ctx.translate(x, y)
                ctx.font = 'bold 26px "Segoe UI", "Helvetica", "Arial", sans-serif'
                ctx.fillStyle = '#a00f2e'
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'

                const prize = this.prizes[i]
                const text = prize.emoji + ' ' + prize.name

                const sectorAngle = ANGLE_STEP
                const availableWidth = 2 * textRadius * Math.sin(sectorAngle / 2)
                const maxWidth = Math.max(80, availableWidth)

                const measuredWidth = ctx.measureText(text).width

                if (measuredWidth > maxWidth) {
                    const lines = this.splitTextIntoLines(ctx, text, maxWidth)
                    const lineHeight = 28
                    const totalHeight = lines.length * lineHeight
                    const startY = -totalHeight / 2 + lineHeight / 2

                    lines.forEach((line, index) => {
                        ctx.fillText(line, 0, startY + index * lineHeight)
                    })
                } else {
                    ctx.fillText(text, 0, 0)
                }

                ctx.restore()
            }

            ctx.beginPath()
            ctx.arc(CENTER_X, CENTER_Y, RADIUS + 5, 0, TAU)
            ctx.strokeStyle = '#e61640'
            ctx.lineWidth = 4
            ctx.globalAlpha = 0.4
            ctx.stroke()
            ctx.globalAlpha = 1.0

            // 绘制指针（在中心圆上方绘制）
            this.drawPointer(ctx, CENTER_X, CENTER_Y)
        },

        /**
         * 绘制指针（位于中心，朝上指向轮盘）
         */
        drawPointer(ctx, centerX, centerY) {
            const pointerHeight = 45
            const pointerWidth = 24

            ctx.save()
            ctx.shadowColor = 'rgba(200, 20, 40, 0.5)'
            ctx.shadowBlur = 10
            ctx.shadowOffsetY = 4

            // 绘制指针三角形（朝上，尖端指向轮盘上方）
            ctx.beginPath()
            ctx.moveTo(centerX, centerY - pointerHeight) // 尖端朝上
            ctx.lineTo(centerX - pointerWidth, centerY + 8) // 左下
            ctx.lineTo(centerX + pointerWidth, centerY + 8) // 右下
            ctx.closePath()
            ctx.fillStyle = '#e61640'
            ctx.fill()
            ctx.restore()

            // 绘制指针底部装饰圆
            ctx.beginPath()
            ctx.arc(centerX, centerY + 12, 16, 0, 2 * Math.PI)
            const circleGradient = ctx.createRadialGradient(
                centerX - 5, centerY + 7, 3,
                centerX, centerY + 12, 16
            )
            circleGradient.addColorStop(0, '#ffe0e3')
            circleGradient.addColorStop(1, '#e61640')
            ctx.fillStyle = circleGradient
            ctx.fill()

            ctx.strokeStyle = '#ffb6c1'
            ctx.lineWidth = 1
            ctx.stroke()

            // 绘制高光
            ctx.beginPath()
            ctx.arc(centerX - 4, centerY + 9, 6, 0, 2 * Math.PI)
            ctx.fillStyle = '#fff0f1'
            ctx.globalAlpha = 0.9
            ctx.fill()
            ctx.globalAlpha = 1.0
        },

        splitTextIntoLines(ctx, text, maxWidth) {
            const lines = []
            let currentLine = ''

            for (let i = 0; i < text.length; i++) {
                const testLine = currentLine + text[i]
                const measuredWidth = ctx.measureText(testLine).width

                if (measuredWidth > maxWidth && currentLine.length > 0) {
                    lines.push(currentLine)
                    currentLine = text[i]
                } else {
                    currentLine = testLine
                }
            }

            if (currentLine) {
                lines.push(currentLine)
            }

            return lines.length > 0 ? lines : [text]
        },

        /**
         * 抽奖动画
         */
        spinWheel() {
            if (this.spinning) return

            this.spinning = true

            const that = this
            const PI = Math.PI
            const TAU = 2 * PI
            const SEGMENT_COUNT = this.prizes.length
            const ANGLE_STEP = TAU / SEGMENT_COUNT

            // 调用后端接口获取中奖结果
            this.giftLotteryApi((targetIdx) => {
                // 计算目标角度
                const targetMid = -PI / 2 + targetIdx * ANGLE_STEP + ANGLE_STEP / 2
                let targetBaseRot = that.normalizeAngle(-PI / 2 - targetMid)

                const current = that.normalizeAngle(that.currentRotation)
                let delta = (targetBaseRot - current + TAU) % TAU
                const extraTurns = 5 + Math.floor(Math.random() * 4)
                const totalDelta = delta + extraTurns * TAU

                const startRot = that.currentRotation
                const startTime = Date.now()
                const duration = 2100

                function animate() {
                    const elapsed = Date.now() - startTime
                    let progress = Math.min(elapsed / duration, 1)
                    const eased = 1 - Math.pow(1 - progress, 3)

                    that.currentRotation = startRot + totalDelta * eased
                    that.drawWheel(that.currentRotation)

                    if (progress < 1) {
                        that.animFrame = setTimeout(animate, 16)
                    } else {
                        that.currentRotation = that.normalizeAngle(targetBaseRot)
                        that.drawWheel(that.currentRotation)

                        const prize = that.prizes[targetIdx]
                        that.prizeDisplay = prize.emoji + ' ' + prize.name
                        that.spinning = false

                        that.animFrame = null

                        // 动画完成后显示弹窗
                        setTimeout(() => {
                            that.showPrizeDialog(prize.name)
                        }, 300)
                    }
                }

                animate()
            })
        },

        /**
         * 显示中奖弹窗
         */
        showPrizeDialog(prizeName) {
            setTimeout(() => {
                this.resetCanvas()
                this.canvasHidden = true
                this.acknowledged = false

                this.lotteryVisible = true
                this.prizeName = prizeName
            }, 50)
        },

        /**
         * 查看礼品详情
         */
        stampShopDetail() {
            this.lotteryVisible = false
            this.canvasHidden = false

            setTimeout(() => {
                this.initCanvas()
            }, 50)

            if (this.isStamp) {
                this.$router.push({
                    path: '/stampShopDetail',
                    query: {
                        id: this.stampExchangeLogId,
                        type: 'stampExchangeLog'
                    }
                })
            } else {
                this.$router.push({
                    path: '/stampShopDetail',
                    query: {
                        id: this.voucherId,
                        type: 'voucher'
                    }
                })
            }
        },

        /**
         * 确认按钮
         */
        submit() {
            this.lotteryVisible = false
            this.canvasHidden = false

            setTimeout(() => {
                this.initCanvas()
            }, 50)
        },

        /**
         * 抽奖API接口
         */
        giftLotteryApi(callback) {
            giftLottery({ activityId: this.activityId }).then(res => {
                if (res.code === this.$API_CODE.OK) {
                    const targetIdx = res.data.index
                    this.stampExchangeLogId = res.data.stampExchangeLogId
                    this.voucherId = res.data.voucherId
                    this.isStamp = res.data.isStamp

                    getVoucher({ id: this.voucherId }).then(res=> {
                        if (res.code === this.$API_CODE.OK) {
                            this.validity = res.data.validity
                            this.expireTime = parseTime(res.data.expirationTime)
                        } else {
                            this.toast(res.message)
                        }
                    })

                    this.getLotteryTicketNumber()
                    callback(targetIdx)
                } else {
                    this.toast(res.message || '抽奖失败')
                    this.spinning = false
                }
            }).catch(err => {
                console.error('抽奖失败:', err)
                this.toast('网络错误')
                this.spinning = false
            })
        },

        /**
         * 切换确认状态
         */
        toggleAcknowledged() {
            this.acknowledged = !this.acknowledged
        },
        back() {
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped lang="scss">
//header区域
#header {
    height: 45px;
    line-height: 45px;
    width: 100%;
    background-color: #ed3f14;
    top: 0;
    position: fixed;
    z-index: 1;
    margin-bottom: 10px;

    .back {
        margin-top: 13px;
        line-height: 35px;
        margin-left: 10px;
        float: left;
    }

    .title {
        color: white;
    }
}
.clock-in-lottery {
    background: linear-gradient(145deg, #ffdfe0 0%, #fef2d3 100%);
    min-height: 100vh;
    padding-bottom: 20px;
}

/* 轮盘容器 */
.wheel-container {
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 28px;
    padding: 38px 15px 15px 15px;;
    box-shadow: 0 15px 25px rgba(230, 22, 64, 0.2), 0 0 0 1px rgba(230, 22, 64, 0.2) inset;
    border: 1px solid rgba(255, 255, 255, 0.8);
    margin: 45px 10px 10px 10px;
}

.wheel-wrapper {
    position: relative;
    width: 260px;
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 10px;
}

.lottery-ticket-badge {
    position: absolute;
    top: -30px;
    right: -68px;
    background: linear-gradient(135deg, #fef2d3, #ffdfe0);
    border: 1px solid #e61640;
    border-radius: 15px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    gap: 4px;
    box-shadow: 0 2px 6px rgba(230, 22, 64, 0.2);
    z-index: 10;
}

.lottery-ticket-label {
    font-size: 11px;
    color: #a00f2e;
    font-weight: 500;
}

.lottery-ticket-value {
    font-size: 16px;
    color: #e61640;
    font-weight: bold;
}

/* Canvas 轮盘 */
.wheel-canvas {
    display: block;
    width: 250px !important;
    height: 250px !important;
    border-radius: 50%;
    box-shadow: 0 10px 18px rgba(230, 22, 64, 0.3), 0 0 0 2px #fef2d3, 0 0 0 4px #ffdfe0;
    background: #fff8f0;
}

/* 控制区域 */
.controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 11px;
}

.spin-btn {
    background: linear-gradient(145deg, #e61640, #ff708d);
    color: #fef2d3;
    font-size: 16px;
    font-weight: 800;
    letter-spacing: 1.25px;
    padding: 12px 64px;
    border-radius: 40px;
    box-shadow: 0 8px 12px rgba(230, 22, 64, 0.4), 0 2px 0 0 #a00f2e, 0 0 10px #ffb0c0 inset;
    border: 1px solid #ffb6c9;
    cursor: pointer;
    transition: all 0.3s;

    &:active {
        transform: translateY(3px);
        box-shadow: 0 4px 9px rgba(230, 22, 64, 0.5), 0 1px 0 0 #a00f2e, 0 0 10px #ffb0c0 inset;
    }

    &:disabled {
        opacity: 0.5;
        transform: translateY(2px);
        box-shadow: 0 5px 7px rgba(230, 22, 64, 0.3), 0 1px 0 0 #7a0b22;
        cursor: not-allowed;
    }
}

.result-panel {
    background: rgba(254, 242, 211, 0.85);
    backdrop-filter: blur(8px);
    border-radius: 25px;
    padding: 7px 17px;
    border: 1px solid #e61640;
    color: #e61640;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 9px;
    box-shadow: 0 5px 9px rgba(230, 22, 64, 0.2);
}

.result-label {
    background: #e61640;
    color: #fef2d3;
    padding: 4px 11px;
    border-radius: 20px;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0.5px;
    border: 1px solid #ffb0c0;
}

.prize-name {
    font-size: 17px;
    min-width: 50px;
    text-align: center;
    filter: drop-shadow(0 0 4px #ff7a9c);
    color: #a00f2e;
}

/* 抽奖规则 */
.rule-container {
    background: #ffffff;
    border: 2px solid #ed3f14;
    border-radius: 8px;
    margin: 10px;
    padding: 15px;
    text-align: center;
}

.rule-title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
    margin-bottom: 10px;
}

.rule-content {
    text-align: left;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    white-space: pre-wrap;    /* 保留换行符 */
    word-break: break-all;    /* 防止长文本溢出 */
}

/* 弹窗样式 */
.message {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-bottom: 10px;
    font-weight: 500;
}

.tip {
    font-size: 13px;
    color: #ed3f14;
    text-align: center;
    margin-bottom: 7px;
}

.tip-emphasis {
    font-size: 16px;
    color: #ed3f14;
    text-align: center;
    margin-bottom: 7px;
}

.dialog-buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 15px;
    gap: 10px;
}

.tip-cancel,
.tip-ok {
    flex: 1;
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    border-radius: 5px;
    border: none;
    padding: 10px 0;
    cursor: pointer;

    &:active {
        opacity: 0.8;
    }
}

.tip-cancel {
    background: linear-gradient(135deg, #409eff, #66b1ff);
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}

.tip-ok {
    background: linear-gradient(135deg, #ea2d53, #f56c6c);
    box-shadow: 0 2px 6px rgba(234, 45, 83, 0.3);
}

.acknowledge-container {
    display: flex;
}

.checkbox-checkbox {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.checkbox-border-small {
    width: 14px;
    height: 14px;
    border: 2px solid #ea2d53;
    border-radius: 50%;
}
</style>
